// @flow
import * as React from 'react'
import styled from 'styled-components'

import Label from './Label'

const CheckBox = ({
  label = 'CheckBox',
  readOnly = false,
  disabled = false,
  className = '',
  input: { value, onChange, ...input },
  marginLeft = false,
  marginBottom = false,
  marginTop = false,
  upperCase = false,
  color = 'monza',
  alignSelf = 'center',
  hiddenLabel = false,
  ...rest
}) => (
  <Wrapper
    className={className}
    marginLeft={marginLeft}
    marginBottom={marginBottom}
    marginTop={marginTop}
    alignSelf={alignSelf}
    onClick={(e) => e.stopPropagation()}
  >
    <Label role='none' checked={value} disabled={disabled || readOnly} $color={color}>
      <StyledInput
        type="checkbox"
        disabled={disabled || readOnly}
        checked={value}
        onChange={() => onChange(!value)}
        {...input}
        {...rest}
      />

      {label && (
        <LabelText
          upperCase={upperCase}
          disabled={disabled || readOnly}
          hiddenLabel={hiddenLabel}
        >
          {label}
        </LabelText>
      )}
    </Label>
  </Wrapper>
)

const Wrapper = styled.div`
  ${(props) => props.marginLeft && `margin-left: 10px`};
  ${(props) => props.marginBottom && `margin-bottom: 10px`};
  ${(props) => props.marginTop && `margin-top: 10px`};
`

export const StyledInput = styled.input`
  position: relative;
  z-index: -1;
  opacity: 0;
  width: 20px;
  height: 20px;

  &:focus {
    opacity: 1;
  }
`

const LabelText = styled.span`
  display: ${(props) => (props.hiddenLabel ? 'none' : 'inline')};
  user-select: none;
  font-size: 15px;
  padding: 0 0 0 12px;
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
`

export { default as Label } from './Label'
export default CheckBox
